

import { ScrollArea } from '@/components/ui/scroll-area';
import { Card, CardContent } from '@/components/ui/card';

export default function EULA() {
  return (
    <section id="eula" className="mb-16">
      <h2 className="text-2xl font-bold mb-6 pb-2 border-b border-neutral-200 text-left">End User License Agreement (EULA)</h2>
      
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <ScrollArea className="h-[400px] rounded-md">
            <div className="p-6 text-left">
              <p className="text-neutral-600 mb-4">
                This End User License Agreement ("Agreement") is a legal agreement between you ("you," "user") and Team Jumo, Inc., doing business as The Mat Monster ("we," "us," or "our") governing your use of The Mat Monster mobile app (the "App") and related services.
              </p>
              <p className="text-neutral-600 mb-6">
                By installing, accessing, or using the App, you agree to be bound by the terms of this Agreement. If you do not agree, do not download or use the App.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">1. License Grant</h3>
              <p className="text-neutral-600 mb-2">We grant you a limited, non-exclusive, non-transferable, revocable license to:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>Download, install, and use one copy of the App on a device that you own or control</li>
                <li>Access and use the App only for your personal, non-commercial training and educational use</li>
              </ul>
              <p className="text-neutral-600 mb-6">
                You may not sublicense, rent, sell, or otherwise distribute the App or any portion of it.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">2. Restrictions</h3>
              <p className="text-neutral-600 mb-2">You agree not to:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>Modify, reverse-engineer, decompile, or disassemble the App</li>
                <li>Circumvent security features or access restrictions</li>
                <li>Use the App for any illegal or harmful purpose</li>
                <li>Copy or distribute any part of the App other than as expressly permitted</li>
                <li>Use the App to develop or promote a competing product</li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">3. Ownership</h3>
              <p className="text-neutral-600 mb-6">
                The App, its content, structure, and features are owned by Team Jumo, Inc. and protected by copyright, trademark, and other laws. You have a license to use it — but no ownership rights.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">4. User-Generated Content</h3>
              <p className="text-neutral-600 mb-2">
                You retain ownership of any content you create or upload within the App (e.g., notes, links, or tutorials).
              </p>
              <p className="text-neutral-600 mb-2">
                By submitting content, you grant us a license to use, display, and distribute it within the App. If your content is approved for monetization, you may be eligible to earn a commission, subject to separate terms.
              </p>
              <p className="text-neutral-600 mb-6">
                Uploading content does not guarantee monetization. We reserve the right to remove or decline any submitted content.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">5. In-App Purchases</h3>
              <p className="text-neutral-600 mb-2">
                The App may offer premium features or content through subscriptions or one-time purchases. These transactions are processed through the Apple App Store, Google Play, or other third-party platforms. You are subject to their billing terms.
              </p>
              <p className="text-neutral-600 mb-6">
                We are not responsible for refund requests, billing issues, or failed purchases — these must be handled through the respective app store.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">6. Data and Privacy</h3>
              <p className="text-neutral-600 mb-6">
                We collect and use data as described in our Privacy Policy. This includes anonymized analytics and limited personal information.
                We do not sell or share your data for advertising or third-party marketing.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">7. Updates and Availability</h3>
              <p className="text-neutral-600 mb-2">
                We may provide updates or bug fixes from time to time. You agree to install updates when available to continue using the App properly.
              </p>
              <p className="text-neutral-600 mb-6">
                We do not guarantee uninterrupted availability or continued access to any particular feature.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">8. Assumption of Risk</h3>
              <p className="text-neutral-600 mb-2">
                Martial arts, including Brazilian Jiu-Jitsu, carry risk of injury. The App provides general informational content only and is not a substitute for live instruction, supervision, or medical advice.
              </p>
              <p className="text-neutral-600 mb-6">
                By using the App, you accept full responsibility for your actions and agree to train safely and within your limits.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">9. Termination</h3>
              <p className="text-neutral-600 mb-6">
                This license is effective until terminated. You may terminate it at any time by deleting the App. We may suspend or revoke your license if you breach this Agreement or misuse the App.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">10. Limitation of Liability</h3>
              <p className="text-neutral-600 mb-2">To the maximum extent permitted by law:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>We provide the App "as is," without warranties of any kind</li>
                <li>We are not liable for any injuries, damages, or losses related to your use of the App</li>
                <li>Our total liability shall not exceed the amount you paid to us (if any) in the last 12 months</li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">11. Governing Law</h3>
              <p className="text-neutral-600 mb-6">
                This Agreement is governed by the laws of the State of Texas, without regard to conflict of laws principles. Any legal action must be brought in a court located in Travis County, Texas.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">12. Contact</h3>
              <p className="text-neutral-600 mb-2">Questions about this Agreement? Reach out:</p>
              <p className="text-neutral-600 mb-2">The Mat Monster</p>
              <p className="text-neutral-600 mb-2">Email: oss@thematmonster.com</p>
              <p className="text-neutral-600 mb-6">Mailing Address: 500 E Whitestone BLVD Unit 902 Cedar Park, TX 78630</p>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </section>
  );
}
